// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2eVGy","headline":"_1E5uA","status":"_1JtEe","no-results-brief":"_1MzR7","cover-button":"_2X2FA"};